import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const cloneRuleSet = api(async function cloneRuleSet({ id }) {
    return mutate(
        gql`
            mutation CloneRuleSet($id: String!) {
                cloneRuleSet(id: $id) {
                    id
                    name
                }
            }
        `,
        { id },
        { returns: "cloneRuleSet" }
    )
})
